module.exports = __webpack_public_path__ + "static/media/akita.421b615b.webp";